<template>
  <div class="text-center align-center">
    <v-layout row wrap>
      <v-flex xs12 md4 class="mx-2">
        <v-btn class="my-15" right x-small fab dark color="warning" fixed>
          <v-icon @click="updateComponent()">mdi-content-save-all</v-icon>
        </v-btn>

        <v-card class="text-center align-center teal darken-4" min-width="340">
          <div :id="'mq'+index"></div>
          <v-card-actions></v-card-actions>
        </v-card>
        <div class="teal darken-4">
          <v-avatar class="mt-2 mx-2" size="55" dark @click="getTypedEquation()" color="primary">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="white">mdi-arrow-right-thick</v-icon>
              </template>
              <span>Enter Expression</span>
            </v-tooltip>
          </v-avatar>
          <ToolBar />
        </div>
      </v-flex>

      <v-flex xs12 md7>
        <div ref="componentSection">
          <div style="color:white" ref="componentContainer">
            <!--Header goes in here-->

            <div
              v-if="content == ''"
              contenteditable
              class="mt-1 h3 text-center align-center teal darken-4"
              style="border-radius:5px"
            >
              <h1 class="h1 text-center">Equation Editor</h1>
              <div :id="'container'+index"></div>
            </div>

            <div v-else v-html="content"></div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ToolBar from "@/components/myLibrary/Toolbar.vue";
import html2canvas from "html2canvas";
//import { VueMathjax } from "vue-mathjax";
import Vue from "vue";

export default {
  props: ["index", "content"],
  mounted() {
    const ed = new window.MathEditor("mq" + this.index);
    this.mqObj = ed;
  },
  components: { ToolBar },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getComponents() {
      return this.$store.getters.getComponents;
    }
  },

  data() {
    return {
      mqObj: null,
      counter: 0
    };
  },
  methods: {
    getTypedEquation() {
      this.counter += 1;
      const div = document.createElement("div");
      div.setAttribute("id", "div" + this.counter);
      div.style.marginBottom = "10px";
      document.getElementById("container" + this.index).appendChild(div);

      const ctor = {} //Vue.extend(VueMathjax);
      const instance = new ctor({
        propsData: {
          formula: "$$ " + this.mqObj.getValue() + "$$" + "$$ \\ $$"
        }
      });
      instance.$mount("#div" + this.counter);
    },
    updateComponent() {
      if (
        !confirm(
          "Once saved, Equations cannot be edited, \n Are you sure you want to save the slide? "
        )
      ) {
        return;
      } else {
        let imgData = null;
        window.scrollTo(430, 0);
        html2canvas(this.$refs.componentSection).then(canvas => {
          imgData = canvas.toDataURL();
          this.$store.commit("updateStoreComponent", {
            index: this.index,
            componentSection: this.$refs.componentContainer.innerHTML,
            imgData: imgData
          });
        });
      } //end of else
    }
  }
};
</script>

<style>
</style>